import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import SchoolForm from './SchoolForm';
import ContactForm from './ContactForm';
import useUpload from 'hooks/useUpload';
import paths from '../../../routes/paths';
import { useSchool, useUpdateSchool } from 'hooks/useBeneficiaries';

function EditSchool() {
  const { upload, loading: uploadLoading } = useUpload();
  const navigate = useNavigate();
  const { id } = useParams();

  const { school } = useSchool(id);
  const { updateSchoolAsync, isUpdating } = useUpdateSchool();

  // TODO: Contact data and mutations need to be migrated to Supabase
  const contactData = null;
  const updateContactLoading = false;
  const insertContactLoading = false;

  const onSubmit = async values => {
    try {
      if (values.school_document && typeof values.school_document !== 'string') {
        const school_document = await upload(values.school_document);
        values.school_document = school_document;
      }

      const schoolData = {
        ...values,
        school_address: values.address,
        school_city: values.city,
        school_email: values.email,
        school_name: values.schoolName,
        school_number: values.contact,
        school_headteacher: values.schoolHeadTeacher
      };

      await updateSchoolAsync({ id, data: schoolData });
      navigate(paths.school);
    } catch (error) {
      console.error('Error updating school:', error);
    }
  };

  const submitContact = values => {
    // TODO: Implement contact update/create when migrated to Supabase
    console.log('Contact submission not yet implemented for Supabase', values);
  };

  return (
    <>
      <SchoolForm
        initValues={school}
        onSubmit={onSubmit}
        loading={isUpdating || uploadLoading}
      />

      <ContactForm
        initValues={contactData?.contact}
        onSubmit={submitContact}
        loading={updateContactLoading || insertContactLoading}
      />
    </>
  );
}

export default EditSchool;
